var multiselectThemeWeb = {
  color: 'primary',
  error: 'alert',
  borders: {
    radius: 'borders.radius',
    inactiveColor: 'border.inactive'
  }
};

export { multiselectThemeWeb };
